import Chart from "react-apexcharts";
import { useTranslation } from "../../../../hooks/useLocalization";
import ReportCard from "./ReportCard";

const ReportUsersCard = ({ report, proPlan, isLoading }) => {
  const { t, tt } = useTranslation();
  return (
    <ReportCard
      variant="primary"
      helpText={t("The total number of unique bot launches")}
      proPlan={proPlan}
      childrenHeader={<>{t("Unique Users")}</>}
      childrenFooter={<span>{tt("Total N", report.total)}</span>}
      isLoading={isLoading}
    >
      <div className="chart w-100">
        <Chart
          options={report.options}
          series={report.data}
          type="area"
          height="200"
        />
      </div>
    </ReportCard>
  );
};

export default ReportUsersCard;
